module.exports = __webpack_public_path__ + "img/3.3bc36936.jpg";